var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright d-flex flex-column align-items-end"},[_vm._v(" © "+_vm._s(_vm.year)+" Guru do Cartola "),_c('br'),_c('span',{staticStyle:{"font-size":".8em","color":"#c9c9c9"}},[_vm._v("v2.20261010.0734")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }